import React from 'react';
import FeatherIcon from 'feather-icons-react';
import { getCostCenterColorTokens } from './costCenter.constants';
import './CostCenterOptionLabel.scss';

const CostCenterOptionLabel = ({
  name,
  icon = 'tag',
  color = '#1f2937',
  filledIcon = false,
  emptyIcon = false,
  vivid = false,
}) => {
  const tokens = getCostCenterColorTokens(color);
  const iconSize = vivid ? 14 : filledIcon ? 12 : 16;
  const iconBorderStyle = emptyIcon
    ? undefined
    : {
        borderColor: tokens.hex,
        background: '#fff',
      };
  return (
    <span
      className={`cost-center-option-label${filledIcon ? ' cost-center-option-label--filled' : ''}${emptyIcon ? ' cost-center-option-label--empty' : ''}${vivid ? ' cost-center-option-label--vivid' : ''}`}
    >
      <span
        className="cost-center-option-label__icon"
        style={iconBorderStyle}
        aria-hidden={emptyIcon}
      >
        {!emptyIcon && (
          <FeatherIcon icon={icon} size={iconSize} color={tokens.hex} />
        )}
      </span>
      <span>{name}</span>
    </span>
  );
};

export default CostCenterOptionLabel;
